var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGroupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1577 22.2709C21.1577 19.9249 17.9882 18.0233 14.0785 18.0233C10.1688 18.0233 6.99931 19.9249 6.99931 22.2709M26.8211 18.0239C26.8211 16.2821 25.0738 14.7852 22.5736 14.1298M1.33594 18.0239C1.33594 16.2821 3.08323 14.7852 5.58347 14.1298M22.5736 8.4467C23.4425 7.66897 23.9894 6.53871 23.9894 5.28073C23.9894 2.93489 22.0878 1.0332 19.7419 1.0332C18.654 1.0332 17.6617 1.44217 16.9102 2.11475M5.58347 8.4467C4.71449 7.66897 4.16762 6.53871 4.16762 5.28073C4.16762 2.93489 6.06932 1.0332 8.41516 1.0332C9.50302 1.0332 10.4954 1.44217 11.2468 2.11475M14.0785 13.7758C11.7326 13.7758 9.831 11.8742 9.831 9.52826C9.831 7.18242 11.7326 5.28073 14.0785 5.28073C16.4244 5.28073 18.3261 7.18242 18.3261 9.52826C18.3261 11.8742 16.4244 13.7758 14.0785 13.7758Z",
    stroke: "black",
    strokeWidth: 1.4563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroupIcon);
export default __webpack_public_path__ + "static/media/Users_Group_icon.5da065240ad2d65cd89a5bcc37f400ed.svg";
export { ForwardRef as ReactComponent };